import { MarkerGlobalSettings } from 'react-give-me-map';
import { PartialDeep } from 'type-fest';

// MapId to settings
export const GLOBAL_MARKER_CONFIG: Record<string, PartialDeep<MarkerGlobalSettings>> = {
    '033acc32-20a3-41da-b92a-20e82aa78ad1': {
        'v2/variant_icon': {
            enableOrderNumberInSmall: false,
            enableOrderNumberInMedium: false,
            collisionPaddingMiddle: 80,
            collisionPaddingLarge: 120
        }
    }
};
